import styled from "styled-components";
import {
  FOOTER_HEIGHT,
  HEADER_HEIGHT,
} from "../../../../utilities/constants"; 
import { Typography } from "@mui/material";

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
`;
export const EditSection = styled.div`
display:flex;
align-items: center;
`


export const AddButton = styled.button`
  padding: 10px;
  width: 150px;
  height: 40px;
  background: #7aba56 0% 0% no-repeat padding-box;
  border-radius: 8px;
  color: #ffffff;
  margin-top: 30px;
  margin-bottom: 20px;
  outline: none;
  border-style: hidden;
  font-size: 16px;
  cursor: pointer;
  margin-right: 10px;
`;

export const RemindersContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 70%;
  flex-direction: column;
  gap: 40px;
  margin-left: 20px;
`;

export const TodoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 70%;
  flex-direction: column;
  gap: 40px;
  margin-left: 20px;
`;

export const SugarLevelContainer = styled.div`
  flex: 1;
  margin-right: 24px;
  border-radius: 12px;
//   background-color: #F5FBFC;
  background-color: #fff;
  margin-bottom: 20px;
  overflow: hidden;
  padding-bottom: 24px;
  @media(max-width:468px){
  margin-right: 0px;
  }
`;


export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  background-color: #2FAED7;
  padding: 16px;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
`;

export const Title = styled.div`
  color: #FFFFFF;
  font-size: 18px;
`;


export const DateText = styled.p`
  font-size: 14px;
  color: #0099CC;
  margin: 24px 0 18px 24px;
`;

export const ToggleButtonContainer = styled.div`
  margin-left: auto;
  color: #FFFFFF;
  font-size: 13px;
  background: #cb8552;
  cursor: pointer;
  margin-top:0px;
    border-radius: 50%;
    width: 25px;
    height: 25px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: 24px;
  margin-bottom: 15px;
  @media(max-width:468px){
    display:block;
  }
`;

export const SugarIcon = styled.img`
  padding: 12px;
  background-color: #EBF7FB;
  border-radius: 8px;
  width: 74px;
  height: 74px;
`;

export const ContentContainer = styled.div`
  margin-left: 24px;
  margin-right: 24px;
  @media(max-width:468px){
    margin-top: 24px;
    margin-left: 0px;
  margin-right: 0px;
  }
`;

export const ContentText = styled.div`
  font-size: 17px;
  color: #000000;
  margin-bottom: 10px;
`;

export const TimeContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Text = styled.div`
  font-size: 13px;
  color: #808080;
  margin-bottom: 3px;
`


export const Value = styled.div`
  font-size: 16px;
  color: #000000;
  max-width: 270px;
`;

export const Frequency = styled.div`
  margin-right: 30px;
`;

export const Days = styled.div`
  margin-right: 30px;
`;

export const Time = styled.div`
`;


export const Edit = styled.button`
  margin-right: 15px;
  padding: 6px 20px;
  background-color: #7ABA56;
  border-radius: 6px;
  border: none;
  font-size: 14px;
  color: #FFFFFF;
  cursor: pointer;
`;

export const Delete = styled.button`
  padding: 6px 20px;
  background-color: #ED4A4A;
  border-radius: 6px;
  border: none;
  font-size: 14px;
  color: #FFFFFF;
  cursor: pointer;
`;



export const ListButtonBase = styled.button`
  border-radius: 12px;
  font-size: 20px;
  padding: 10px 20px;
  border: ${({ $active }) => ($active ? 'none' : '1px solid #2FAED7')};
  background-color: ${({ $active }) => ($active ? '#EBF7FB' : '#FFFFFF')};
  color: ${({ $active }) => ($active ? '#000000' : '#000000')};
  cursor: pointer;
  margin-left: 10px;
`;

export const ReviewButtonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    margin-top: 22px;
    gap: 10px;
`;

export const ListAddTempWrapper = styled.div`
    margin-bottom: 20px;
`;

export const ModalHeader = styled(Typography)`
  color: #0099CC;
  font-size: 24px !important;
  margin: 28px 0 0 30px !important;
`;

export const ModalBody = styled.div`
  margin: 25px 0 0 35px;
  position: relative;
  flex: 1;
  overflow-y: auto;
`;





export const SaveButton = styled.button`
  background-color: #7aba56;
  justify-content: center;
  align-items: center;
  display: flex;
  border-radius: 8px;
  border: none;
  color: white;
  font-size: 14px;
  cursor: pointer;
  padding: 11px 56px;
  margin: 18px 25px;
`;

export const NoButton = styled.button`
  background-color: #ED4A4A;
  justify-content: center;
  align-items: center;
  display: flex;
  border-radius: 8px;
  border: none;
  color: white;
  font-size: 14px;
  cursor: pointer;
  padding: 11px 56px;
  margin: 18px 25px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
  justify-content: center;
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
`;

export const ButtonWrapperTodo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
  justify-content: flex-end;
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
`;

export const DeleteText = styled.div`
  font-size: 16px;
  color: #000000;
  font-weight: 800;
`

export const RadioMainContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

export const RadioButtonContainer = styled.div`
  border: 1px solid #92D4E9;
  font-size: 16px;
  color: ${(props) => props.$isSelected ? '#000000' : '#808080'};
  border-radius: 12px;
  padding: 10px;
  margin-bottom: 10px;
  margin-right: 10px;
  background-color: ${(props) => props.$isSelected ? '#EBF7FB' : '#FFFFFF'};
`;

export const RadioButtonLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  // Add more styles as needed
`;

export const RadioButton = styled.input.attrs({ type: 'radio' })`
  cursor: pointer;
  accent-color: #0099CC;
  opacity: 0; // hide the radio button visually
  width: 0; // reduce the width to zero
  height: 0; // reduce the height to zero
  position: absolute; // take it out of the normal flow
  margin: 0;
  padding: 0;
`;

export const SugarLevelFor = styled.div`
  margin-bottom: 15px;
  width: 50%;
`;

export const SugarLevelForText = styled.div`
  font-size: 13px;
  color: #808080;
  margin-bottom: 10px;
`;

const sharedInputStyles = `
    border-radius: 12px;
    border: 1px solid #92D4E9;
    padding: 10px;
    margin-bottom: 16px;
    font-size: 13px;
`;

export const Input = styled.input`
    flex: 1;
    ${sharedInputStyles}
`;

export const InputUnitWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 60%;
`;

export const UnitLabel = styled.span`
  position: absolute;
  right: 10px;
  margin-bottom: 16px;
  margin-top: 10px;
  font-size: 13px;
`;

export const EmptyListMessage = styled.div`
  margin-top: 10px;
  padding: 20px;
  color: red;
  text-align: center;
`;